export default "/images/vendor/flag-icon-css/flags/4x3/sv.svg?3bb132d79aef68d7fe4173688648ef29";